import { render, staticRenderFns } from "./ConfirmAccountRegistrationModal.vue?vue&type=template&id=8d6cd620"
import script from "./ConfirmAccountRegistrationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountRegistrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports